import { Lock } from '@nosinovacao/fe-icons';
import { Button, Otp, useI18n, widgets } from '@nosinovacao/nosid-mfe-common';
import { AvatarPictureLight } from '../../../../-components/avatar-picture.light';
import { type PinValidationProps } from '../-model/props';

export function PinValidationLight({
  form,
  handleSubmit,
  handlePinChange,
  onContactVerification,
  avatarUri,
  nickname,
}: Readonly<PinValidationProps>) {
  const { t } = useI18n();

  return (
    <form
      data-tid="form-pin-validation"
      onSubmit={form.handleSubmit(handleSubmit)}
      className="flex size-full flex-col items-center overflow-y-auto px-1"
    >
      <div className="flex w-full flex-col items-center gap-8">
        <div className="flex flex-col items-center gap-2">
          <AvatarPictureLight size={96} src={avatarUri} name={nickname} />
          <span
            data-tid="text-profile-name"
            className="flex items-center gap-1 font-medium text-nos-neutral-900 font-text-p1"
          >
            <Lock width={16} height={16} />
            {nickname}
          </span>
        </div>
        <div className="flex w-full flex-col items-center gap-14">
          <Otp
            data-tid="otp-pin-validation"
            id="profile-pin-validation"
            skin="light"
            length={widgets.PinCodeLength}
            type="password"
            errors={form.errors.pin}
            value={form.value.pin}
            onChange={handlePinChange}
          />
          <button
            data-tid="button-recover-pin"
            type="button"
            onClick={onContactVerification}
            className="text-sm font-medium text-nos-neutral-1000 underline"
          >
            {t('TvProfiles.PinValidation.RecoverPin')}
          </button>
        </div>
      </div>
      <div className="sticky bottom-0 mt-auto w-full bg-nos-neutral-0 pt-8 max-tablet:grid max-tablet:pb-8">
        <Button
          data-tid="button-submit-pin-validation"
          skin="light"
          type="submit"
          className="w-full tablet:w-fit"
          disabled={form.value.pin.length !== widgets.PinCodeLength}
        >
          {t('TvProfiles.PinValidation.Submit')}
        </Button>
      </div>
    </form>
  );
}
